import React, { useEffect, useMemo, useState } from 'react'
import { ResponseRequest } from 'components/Types/GeneralTypes';
import { alertService } from 'components/Varios/alert_service'
import Cargando from 'components/Varios/Cargando';
import PDFViewer from 'components/Varios/PDFViewer';
import { Button, Col, Row, FormGroup } from 'react-bootstrap'
import { Label } from 'reactstrap';
import { ObtenerPdfHojaVidaConsultor, ObtenerPdfHojaVidaConsultorAcreditacionEURACE, ObtenerPdfHojaVidaConsultorAcreditacionAACSB, ObtenerPdfHojaVidaConsultorAcreditacionABET } from 'components/UsuarioGeneral/Hoja de Vida/FunctionsGenerarHojaVida'
import AsyncSelect from 'react-select/async';
import configData from "config.json"

import Swal from 'sweetalert2'
import SelectItem2 from '../../Varios/SelectNew';
import WarningSVG from "assets/icons/Permisos/Informativa R.svg"

export default function ConsultorGenerarHojaVida() {
    const [urlHojaVida, seturlHojaVida] = useState<string>("")
    const [loading, setloading] = useState<boolean>(false)
    const [loadingDatos, setloadingDatos] = useState<boolean>(false)
    const [tipoHojaVida, setTipoHojaVida] = useState("");
    const [idpersona, setidpersona] = useState(0);

    const [inputValue, setValue] = useState('');
    const [selectedValue, setSelectedValue] = useState(null);

    const opciones_hojavida = [
        { key: "ESPOL", value: "ESPOL" },
        { key: "EURACE", value: "EUR-ACE" },
        { key: "AACSB_ES", value: "ACBSP - español" },
        { key: "AACSB_EN", value: "ACBSP - inglés" },
        { key: "ABET", value: "ABET" },
    ];

    const handleInputChange = value => {
        setValue(value);
    };

    const handleChange = value => {
        setSelectedValue(value);
        setidpersona(value.idpersona);
    }

    const loadOptions = (inputValue) => {
        if (inputValue.length > 3) return fetch(`${configData.SERVER_URL}FormularioController/ConsultorBuscarPersona/${inputValue}`).then(res => res.json()).then(result => result.entTabla);
        else return [];
    };

    const ViewerHojaDeVida = useMemo(() => {
        if (loading) {
            return <Cargando mensaje='Generando Hoja de Vida' />
        }
        if (urlHojaVida) {
            return (
                <Row>
                    <Col xl={8} md={10} sm={12}>
                        <PDFViewer url={urlHojaVida} heightValue={"700px"} />
                    </Col>
                </Row>

            )
        }
        else {
            return undefined
        }

    }, [urlHojaVida, loading])


    const GenerarHojaVida = async () => {
        var error = "";

        if (idpersona === 0) error += "Seleccione una persona. <br />";
        if (!tipoHojaVida) error += "Seleccione un tipo de hoja de vida. <br />";

        if (error !== "") {
            Swal.fire({
                html: error,
                imageUrl: `${WarningSVG}`,
                imageHeight: 100,
                imageAlt: "Anuncio",
                confirmButtonText: "Entendido",
                confirmButtonColor: "#243165",
            });
            return;
        }

        alertService.clear();
        setloading(true);

        try {
            let resultado: ResponseRequest | undefined;

            switch (tipoHojaVida) {
                case "ESPOL":
                    resultado = await ObtenerPdfHojaVidaConsultor(idpersona.toString());
                    break;
                case "EURACE":
                    resultado = await ObtenerPdfHojaVidaConsultorAcreditacionEURACE(idpersona.toString());
                    break;
                case "AACSB_ES":
                    resultado = await ObtenerPdfHojaVidaConsultorAcreditacionAACSB(idpersona.toString(), "ES");
                    break;
                case "AACSB_EN":
                    resultado = await ObtenerPdfHojaVidaConsultorAcreditacionAACSB(idpersona.toString(), "EN");
                    break;
                case "ABET":
                    resultado = await ObtenerPdfHojaVidaConsultorAcreditacionABET(idpersona.toString(), "ES");
                    break;
            }

            if (resultado?.status === 200) {
                seturlHojaVida(resultado.dataResponse);
                alertService.success("Se ha generado la hoja de vida con éxito.");
            } else {
                alertService.error(resultado?.errorMessage ?? "Error inesperado.");
            }

        } finally {
            setloading(false);
        }
    };

    return (
        <div className="content">
            <div className='titulo_seccion mb-4'>Generar Hoja de Vida</div>

            <Row >
                <Col md={6}>
                    <FormGroup className="mb-3">
                        <Label for="">Buscar Persona*</Label>
                        <AsyncSelect
                            cacheOptions
                            defaultOptions
                            placeholder="Buscar persona - Apellidos | Identificación"
                            loadingMessage={() => "Buscando . . ."}
                            noOptionsMessage={() => "No existe información para mostrar"}
                            value={selectedValue}
                            getOptionLabel={e => e.apellidos + " " + e.nombres}
                            getOptionValue={e => e.idpersona}
                            loadOptions={loadOptions}
                            onInputChange={handleInputChange}
                            onChange={handleChange}
                        />
                    </FormGroup>
                </Col>
            </Row >

            <Row>
                <Col md={6}>
                    <FormGroup className="mb-3">
                        <Label for="tipoHojaVida">Tipo de Hoja de Vida*</Label>
                        <SelectItem2
                            options={opciones_hojavida.map((op) => ({
                                value: op.key,
                                label: op.value,
                            }))}
                            placeholder="-- Seleccione una opción --"
                            name="tipoHojaVida"
                            id="tipoHojaVida"
                            icon="fa-caret-down"
                            value={tipoHojaVida}
                            onChange={(selectedOption: any) => setTipoHojaVida(selectedOption)}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <Button
                        color="primary"
                        className="mt-3"
                        disabled={loading}
                        onClick={GenerarHojaVida}
                    >
                        Generar Hoja de Vida
                    </Button>
                </Col>
            </Row>

            {
                ViewerHojaDeVida
            }
        </div>
    )
}